import { Tooltip } from '@cian/ui-kit';
import * as React from 'react';

import { CompareButtonControl } from './CompareButtonControl';
import { ADD_TO_COMPARE_TOOLTIP, REMOVE_FROM_COMPARE_TOOLTIP } from './constants';

interface ICompareButtonWithTooltipProps {
  disabled?: boolean;
  isAdded: boolean;
  onClick(): void;
}

export function CompareButtonWithTooltip({ disabled = false, isAdded, onClick }: ICompareButtonWithTooltipProps) {
  if (disabled) {
    return <CompareButtonControl isAdded={isAdded} onClick={onClick} />;
  }

  return (
    <Tooltip placement="top" title={isAdded ? REMOVE_FROM_COMPARE_TOOLTIP : ADD_TO_COMPARE_TOOLTIP}>
      <CompareButtonControl isAdded={isAdded} onClick={onClick} />
    </Tooltip>
  );
}
